// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API
const { Post } = axiosInstanceApiGateway

export const postOrderPooling_OrderPooling = (data: any): any =>
  axios.put(`${baseUrl}/api/packer/order/pooling/assign-driver`, data)

export const getDataReceiptPackerOrder = (order_id: any, params?: any): any => {
  if (params) {
    return axios.get(`${baseUrl}/api/order/${order_id}/receipt${params}`)
  }
  return axios.get(`${baseUrl}/api/order/${order_id}/receipt`)
}

export const getDataProductSuper = (order_id: any): any =>
  axios.get(`${baseUrl}/api/v2/order/${order_id}/products`)
export const postInitPackage = (orderId: any, data: any): any => {
  if (data) {
    return axios.post(`${baseUrl}/api/order/${orderId}/receipt-init`, data)
  }
  return axios.post(`${baseUrl}/api/order/${orderId}/receipt-init`)
}

export const getDataReceiptPackerOrderSuper = (order_id: any, query: any): any =>
  axios.get(`${baseUrl}/api/order/${order_id}/receipt${query}`)
export const getImageFile = (remote_URL: any): any =>
  axios.get(remote_URL, { responseType: 'blob' })

export const putChangeDriverOnDelivery = (order_id: any, data: any): any =>
  axios.put(`${baseUrl}/api/packer/order/${order_id}/change-delivery-driver`, data)

export const getProductDetailExpiredSearchQrCode = ({
  qr_code,
  quantity,
  orderID,
  type,
}: any): any =>
  axios.put(`${baseUrl}/api/packer/order/${orderID}/scan-product`, {
    qr_code,
    quantity,
    product_type: type ? 3 : null,
  })
export const getKitchenItemByItemID = (payload: any): any =>
  Post({
    url: `/fulfillment/internal/v1/packing/orders/${payload.order_id}/scan-kitchen`,
    data: payload,
  })
export const getProductDetailExpiredSearchQrCodeSuper = ({
  qr_code,
  quantity,
  orderID,
  type,
  location_id,
}: any): any =>
  axios.put(`${baseUrl}/api/packer/super/order/${orderID}/scan-item`, {
    qr_code,
    quantity,
    product_type: type ? 3 : null,
    location_id,
  })

export const putDeleteScannedProduct = (orderID: any, payload: any): any =>
  axios.put(`${baseUrl}/api/packer/order/${orderID}/remove-scan-product`, payload)

export const putDeleteScannedProductSuper = (orderID: any, payload: any): any =>
  axios.put(`${baseUrl}/api/packer/super/order/${orderID}/remove-scan-item`, payload)

export const getRemovableItems = (orderID: any): any =>
  axios.get(`${baseUrl}/api/packer/order/${orderID}/removable-item`)
export const getRemovableItemsSuper = (orderID: any, locationId: any): any =>
  axios.get(`${baseUrl}/api/packer/super/order/${orderID}/removable-item`, {
    params: { locationId },
  })

// Scan removable items
export const postScanToRemoveItem = (orderID: any, payload: any): any =>
  axios.post(`${baseUrl}/api/packer/order/${orderID}/scan-product/remove`, payload)
// Scan removable items super
export const postScanToRemoveItemSuper = (orderID: any, payload: any): any =>
  axios.post(`${baseUrl}/api/packer/super/order/${orderID}/scan-item/remove`, payload)

// Astro relabel
export const getRelabelItems = (id: any): any =>
  axios.get(`${baseUrl}/api/packer/order/${id}/item-label`)

// Notify partial fulfill for external order (i.e GrabMart, etc)
export const notifyPartialFulfill = (orderId: any): any =>
  axios.post(`${baseUrl}/api/packer/order/${orderId}/notify-partial-fulfill`)
